import { posToDOMRect } from "@tiptap/core";
import { SoundCloudSmall, SoundSmall, SpotifySmall } from "@wix/wix-ui-icons-common";
import {
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common";
import {
  AUDIO_INSERT_AUDIO_MODAL_ID,
  AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
  AUDIO_INSERT_SPOTIFY_MODAL_ID
} from "./consts";
import { audioConverter } from "./converters/audio-converter";
import { DEFAULT_CONFIGS, RICOS_DEFAULTS } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { InsertModal } from "./modals/InsertModal";
import { AudioSettingsModal } from "./modals/SettingsModal";
import { tiptapExtensions } from "./tiptap/tiptap";
import { AUDIO_TYPE } from "./types";
const pluginAudio = (config = {}) => {
  return {
    config: { ...DEFAULT_CONFIGS.editor, ...config },
    type: AUDIO_TYPE,
    tiptapExtensions,
    pmMarkConverters: [],
    pmNodeConverters: [audioConverter],
    toolbar: {
      names: [RicosPluginToolbarNames.AUDIO],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    __exports: {
      InsertModal,
      SettingsModal: AudioSettingsModal
    },
    getQuickActions: ({ config: config2, pluginServices }) => {
      const {
        handleFileSelection,
        handleFileUpload,
        disableDownload = true,
        fetchData
      } = config2 || {};
      const modalBaseProps = {
        handleFileSelection,
        handleFileUpload,
        fetchData
      };
      const isMobile = pluginServices.context.isMobile;
      return [
        {
          id: "audioFile",
          title: "QuickActionsPlugin_ActionTitle_AudioFile",
          icon: SoundSmall,
          section: quickActionsModalSections.Media,
          tags: ["music", "sound", "podcast", "voice", "recording", "song", "clip", "track"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_AUDIO_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS, disableDownload },
                modalId: AUDIO_INSERT_AUDIO_MODAL_ID,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: "bottom-end"
              },
              mobileLayout: "drawer"
            });
          }
        },
        {
          id: "soundcloud",
          title: "QuickActionsPlugin_ActionTitle_SoundCloud",
          icon: SoundCloudSmall,
          section: quickActionsModalSections.Embed,
          tags: [
            "music",
            "sound",
            "podcast",
            "voice",
            "recording",
            "song",
            "clip",
            "link",
            "streaming",
            "track"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS },
                modalId: AUDIO_INSERT_SOUNDCLOUD_MODAL_ID,
                embedType: true,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: "bottom-end"
              },
              mobileLayout: "drawer"
            });
          }
        },
        {
          id: "spotify",
          title: "QuickActionsPlugin_ActionTitle_SpotifyTrack",
          icon: SpotifySmall,
          section: quickActionsModalSections.Embed,
          tags: [
            "music",
            "sound",
            "podcast",
            "voice",
            "recording",
            "song",
            "clip",
            "link",
            "streaming",
            "track",
            "playlist"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            modalService.togglePluginPanel({
              id: AUDIO_INSERT_SPOTIFY_MODAL_ID,
              Component: InsertModal,
              componentProps: {
                componentData: { ...RICOS_DEFAULTS },
                modalId: AUDIO_INSERT_SPOTIFY_MODAL_ID,
                embedType: true,
                ...modalBaseProps
              },
              isMobile,
              positioning: {
                referenceElement: {
                  getBoundingClientRect: () => posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  )
                },
                placement: "bottom-end"
              },
              mobileLayout: "drawer"
            });
          }
        }
      ];
    }
  };
};
export {
  pluginAudio
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
